'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.googleAuthProvider = exports.firebase = undefined;

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var config = {
    apiKey: env.FIREBASE_API_KEY,
    authDomain: env.FIREBASE_AUTH_DOMAIN,
    projectId: env.FIREBASE_PROJECT_ID
};

firebase.initializeApp(config);

var googleAuthProvider = new firebase.auth.GoogleAuthProvider();

exports.firebase = firebase;
exports.googleAuthProvider = googleAuthProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZmlyZWJhc2UvZmlyZWJhc2UuanMiXSwibmFtZXMiOlsiZmlyZWJhc2UiLCJjb25maWciLCJhcGlLZXkiLCJlbnYiLCJGSVJFQkFTRV9BUElfS0VZIiwiYXV0aERvbWFpbiIsIkZJUkVCQVNFX0FVVEhfRE9NQUlOIiwicHJvamVjdElkIiwiRklSRUJBU0VfUFJPSkVDVF9JRCIsImluaXRpYWxpemVBcHAiLCJnb29nbGVBdXRoUHJvdmlkZXIiLCJhdXRoIiwiR29vZ2xlQXV0aFByb3ZpZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0lBQVlBLFE7Ozs7QUFFWixJQUFNQyxTQUFTO0FBQ1hDLFlBQVFDLElBQUlDLGdCQUREO0FBRVhDLGdCQUFZRixJQUFJRyxvQkFGTDtBQUdYQyxlQUFXSixJQUFJSztBQUhKLENBQWY7O0FBTUFSLFNBQVNTLGFBQVQsQ0FBdUJSLE1BQXZCOztBQUVBLElBQU1TLHFCQUFxQixJQUFJVixTQUFTVyxJQUFULENBQWNDLGtCQUFsQixFQUEzQjs7UUFFU1osUSxHQUFBQSxRO1FBQVVVLGtCLEdBQUFBLGtCIiwiZmlsZSI6ImZpcmViYXNlLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBmaXJlYmFzZSBmcm9tICdmaXJlYmFzZSc7XG5cbmNvbnN0IGNvbmZpZyA9IHtcbiAgICBhcGlLZXk6IGVudi5GSVJFQkFTRV9BUElfS0VZLFxuICAgIGF1dGhEb21haW46IGVudi5GSVJFQkFTRV9BVVRIX0RPTUFJTixcbiAgICBwcm9qZWN0SWQ6IGVudi5GSVJFQkFTRV9QUk9KRUNUX0lEXG59O1xuXG5maXJlYmFzZS5pbml0aWFsaXplQXBwKGNvbmZpZyk7XG5cbmNvbnN0IGdvb2dsZUF1dGhQcm92aWRlciA9IG5ldyBmaXJlYmFzZS5hdXRoLkdvb2dsZUF1dGhQcm92aWRlcigpO1xuXG5leHBvcnQgeyBmaXJlYmFzZSwgZ29vZ2xlQXV0aFByb3ZpZGVyIH07Il19


//////////////////
// WEBPACK FOOTER
// ./src/client/firebase/firebase.js
// module id = 720
// module chunks = 0